import { NAV_PATHS } from '@modules/common/constants';
import { SearchQuery } from '@modules/feed/types';
import { getSearchParams } from '@modules/feed/utils/getSearchParams';
import pathJoin from 'v2/core/utils/path';

interface getSearchMetadataUrlOptions extends SearchQuery {
  tenantSlug?: string;
  isSearchToFeedEnabled: boolean;
}

export const getSearchMetadataUrl = ({
  tenantSlug,
  duration,
  whereClause,
  isSearchToFeedEnabled,
}: getSearchMetadataUrlOptions) => {
  const searchParams = getSearchParams({
    duration,
    whereClause,
  });
  return (
    pathJoin(
      window.location.origin,
      tenantSlug ?? '',
      `/${isSearchToFeedEnabled ? NAV_PATHS.FEED : NAV_PATHS.SEARCH}`,
    ) + searchParams
  );
};
